import { Injectable } from '@angular/core';
import { FilterResponse, PrefixboxFilterCustomization } from 'haba-emporix';

export const PERSONALIZATION_FACET = 'personalization';

const PERSONALIZATION_TRUE = 'true';
const PERSONALIZATION_FALSE = 'false';
const PERSONALIZATION_TRUE_LABEL = 'habaSearch.filters.personalization';

export function transformPersonalizationFacet(filters: FilterResponse[]): FilterResponse[] {
  if (!filters?.length) return filters;

  return filters
    .map((facet) => {
      if (facet.name !== PERSONALIZATION_FACET) return facet;

      const values = (facet.values ?? [])
        .filter((value) => value.name !== PERSONALIZATION_FALSE)
        .map((value) =>
          value.name === PERSONALIZATION_TRUE
            ? { ...value, displayName: PERSONALIZATION_TRUE_LABEL }
            : value
        );

      return { ...facet, values };
    })
    .filter((facet) => facet.name !== PERSONALIZATION_FACET || facet.values.length > 0);
}

@Injectable()
export class PersonalizationFilterCustomization extends PrefixboxFilterCustomization {
  override transformFacets(filters: FilterResponse[]): FilterResponse[] {
    return transformPersonalizationFacet(filters);
  }
}
